<div class="sso-loading-overlay">
    <h3 class="title">A iniciar acesso seguro...</h3>
    <p class="message">Aguarde enquanto redirecionamos para a Microsoft.</p>
    <small class="helper-text">Isto pode demorar alguns segundos.</small>
</div>